// frontend/src/MediaAssets/mediaAssetsSelectors.ts
import type { IMediaAsset } from "@multiconsult-group/multiplacer-core";
import { ZMediaAssetKeyKnown } from "@multiconsult-group/multiplacer-core";
import { IRootState } from "../app/store";
import { openapi } from "../../openapi";

const EMPTY_MEDIA_ASSETS: IMediaAsset[] = [];

/**
 * Read cached media assets response from RTK Query (no network call here).
 */
export const selectHttpMediaAssetsCached = (state: IRootState): IMediaAsset[] => {
  // This endpoint has no input (z.void), so args is `undefined`
  return (
    (openapi.endpoints.getMultiplacerMediaAssets.select(undefined)(state).data as IMediaAsset[]) ??
    EMPTY_MEDIA_ASSETS
  );
};

/**
 * Missing keys from the "known keys" enum, based on what's currently in cache.
 */
export const selectMissingKnownMediaAssetKeys = (state: IRootState): string[] => {
  const assets = selectHttpMediaAssetsCached(state);
  const existingKeys = new Set(assets.map((a) => a.key));
  return ZMediaAssetKeyKnown.options.filter((k) => !existingKeys.has(k));
};
